module.exports = __webpack_public_path__ + "img/fig07.4d9eb5c6.jpg";